import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix

/**
 * Class representing the FilterAgentListView.
 * @extends JetView
 */
export default class FilterAgentListView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section of the filter form
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for User ID
                    name: 'Id',
                    type: 'number',
                    label: _("<span class='icon-drivers-license-o'></span> ID Usuario"),
                    hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-filterByUser',
                    labelPosition: 'top',
                    placeholder: _('ID Usuario'),
                },
            ],
        };

        // Center left section of the filter form
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for User Email
                    name: 'Login',
                    label: _("<span class='icon-mail'></span> Usuario (Correo electrónico)"),
                    labelPosition: 'top',
                    placeholder: _('Usuario (Correo electrónico)'),
                },
            ],
        };

        // Center right section of the filter form
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Dropdown for Registration Status
                    name: 'IsRegisterActivate',
                    label: _("<span class='icon-state'></span> Estado de Registro"),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    value: '',
                    options: [
                        { id: '', value: _('Todos') },
                        { id: 'A', value: _('Activo') },
                        { id: 'I', value: _('Inactivo') },
                        { id: 'R', value: _('Rechazado') },
                    ],
                },
            ],
        };

        // Right section of the filter form
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Dropdown for Activation Status
                    name: 'IsActivate',
                    label: _("<span class='icon-state'></span> Estado"),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    value: '',
                    options: [
                        { id: '', value: _('Ambos') },
                        { id: 'A', value: _('Activo') },
                        { id: 'I', value: _('Inactivo') },
                    ],
                },
            ],
        };

        // Upper section containing the left filter
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left], // Only left section for now
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 5,
            cols: [
                {},
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form inputs
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    hotkey: 'enter', // Trigger on Enter key
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('playersList:filter', [filterdata]); // Trigger filter event with values
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }
}

// FILE DOCUMENTED
